module.exports = __webpack_public_path__ + "static/media/url-white-x.8fa31fe8.png";